import { NavLink, useParams,useLocation } from "react-router";
import TypeFraisItemComponent from "../../components/TypeFrais/TypeFraisItem";
import { useTypeFraisByIdQuery } from "../../stores/OkOkStore";
import { useTrads } from "../../contexts/trads/useTrads";
import type { LocationState } from "../../types/QueryParameters";

function TypeFraisItem(){
    const location = useLocation();
    const state = location.state as LocationState | undefined;
    const params = useParams();

    const { data:typefrais, error, isLoading } = useTypeFraisByIdQuery(params.id??"0");
    const {translate}=useTrads();

    return (

        error ? (
            <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>
        ) : isLoading ? (
            <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
        ) : typefrais ? (
            <div>
                <nav>
                    <NavLink to={`/type_frais/${typefrais.id.toString()}/edit`}>{translate('btn_edit')}</NavLink>
                </nav>
                {state?.modified && <p className="p-3 mb-2 bg-success text-white">{translate('msg_typefrais_updated')}</p>}
                <TypeFraisItemComponent typefrais={typefrais}  />
            </div>
        
        ):null
    );
}
export default TypeFraisItem;